export const en = {
  "common.signOut": "Sign out",
  "common.loginRegister": "Login / Register",
  "common.follow": "Follow {brand}",
  "common.superAdmin": "● Super Admin",
  "common.viewer": "● Viewer",
  "common.language": "Language",

  "lock.unlock": "Unlock",
  "lock.locked": "Locked",

  "nav.database": "ECU Database",
  "nav.software": "Software Gallery",
  "nav.binConverter": "Converter",
  "nav.checksum": "Checksum",
  "nav.fileService": "File Service",
  "nav.pinout": "ECU Pinout",
  "nav.xdfAdx": "XDF / ADX Unlock",
  "nav.immo": "IMMO Service",
  "nav.recovery": "Recovery Generator",
  "nav.mapEditor": "Map Editor",
  "nav.hondaFlashtools": "Honda Flash Tools",
  "nav.yamahaFlashtools": "Yamaha Flash Tools",
  "nav.autoMapFinder": "Auto Map Finder",
  "nav.seedKey": "Seed Key View",
  "nav.diagram": "Diagram Tool",
  "nav.desktopApp": "Desktop App",
  "nav.ecuDatabaseAdmin": "Update Info Bike",
  "nav.ecuLibrary": "Update Basemap",
  "nav.userControl": "User Control",
  "nav.appUpdate": "App Update",

  "guard.flashing": "Flashing in progress — can't leave. Press Abort then Disconnect first.",
  "guard.leave": "Map Editor is locked — unsaved edits, Flash Tools active, or an FTDI device is still connected.\n\nLeave the page? Unsaved changes may be lost.",

  "mapeditor.narrowbandNote": "O2 narrowband: most accurate around 14.7 (idle/cruise). Correction capped at ±{step}% per cell. Record while riding so every RPM×TPS area gets samples.",
  "mapeditor.noSamples": "No live samples yet. Enable Live then Record while riding.",

  "login.tagline": "ECU Tuning",
  "login.tabLogin": "Login",
  "login.tabRegister": "Register",
  "login.name": "Name",
  "login.phone": "Phone",
  "login.email": "Email",
  "login.country": "Country",
  "login.password": "Password",
  "login.confirm": "Repeat Password",
  "login.submitLogin": "Sign in",
  "login.submitRegister": "Create Account",
  "login.forgotQ": "Forgot password?",
  "login.forgotAction": "Reset via admin",
  "login.forgotHint": "Enter your account Name, Email & Phone. The admin will check and contact you with your password.",
  "login.forgotSubmit": "Send Request to Admin",
  "login.pendingTitle": "Waiting for admin approval",
  "login.pendingBody": "Account {email} has been created. You can sign in once an admin approves.",
  "login.backToLogin": "Back to Login",
  "login.toastSuccess": "Signed in successfully",
  "login.toastPwMismatch": "Password and repeat password do not match",
  "login.toastRegistered": "Account created — waiting for admin approval",
  "login.toastForgotFill": "Fill in at least Name and Email",
  "login.toastForgotSent": "Request sent to admin",
  "login.err": "Something went wrong. Please try again.",
};
